export default {
  home: 'Home',
  shopLocal: 'Shop Local EVs',
  shopDealers: 'Shop Dealers',
  viewVehicleDetails: 'View Vehicle Details',
  browseInventory: 'Browse Nearby Inventory',
  dealerDirectory: 'Local Dealers',
  evFacts: 'EV Facts',
  faq: 'FAQ',
  electricVehicles: 'Electric Vehicles',
  usedElectricVehicles: 'Used Electric Vehicles',
  compareVehicles: 'Compare Vehicles',
  incentives: 'Incentives',
  chargingStations: 'Charging Stations',
  homeChargers: 'Home Chargers',
  dealers: 'Dealers',
  newVehicles: 'New Vehicles',
  electricians: 'Electricians',

  electricity: 'Electricity',
  gasoline: 'Gasoline',
  total: 'Total',
  description: 'Description',
  detailedCalculations: 'Detailed Calculations',
  charging: 'Charging',
  emissions: 'Emissions',
  source: 'Source',
  vehicles: 'Vehicles',
  make: 'Make',
  model: 'Model',
  all: 'All',
  age: 'Age',
  zipcode: 'Zipcode',

  'homepage.bigPromise.title': 'Discover, Save and Charge Ahead.',
  'homepage.bigPromise.description':
    'This guide can help you make an informed decision by providing detailed info on EVs, savings and charging.',
  'homepage.bigPromise.findYourEvMatch': 'Find Your EV Match',
  'homepage.bigPromise.seeYourRebates': 'See Your Rebates',
  'homepage.bigPromise.howChargingWorks': 'How Charging Works',

  faqTitle: 'Why Drive Electric?',
  faqDescription:
    'Driving an EV comes with great benefits — for your wallet, your driving experience, and the environment.',

  dealersHeading: 'Locally Owned EV Dealers',
  dealersSubheading:
    "The dealers below work closely with Austin Energy to provide a great EV shopping experience. Contact and visit these dealers with the confidence that they'll help you pick the right vehicle for you.",

  'dealer.contact': 'Contact',
  'dealer.map': 'Map',
  'dealer.website': 'Website',
  'dealer.oemLogoAlt': '{brand} logo',

  personalizeIncentives: 'Personalize Incentives',

  'home.card.electricVehicles': 'Shop Local Electric Vehicles',

  'ae-erides-bikemap-faq1': 'Austin Bike Map',
  'ae-erides-bikemap-faq1-a': "Explore Austin's growing bike lanes and trails.",

  'ae-faq1': '🚗💵 Save Money Every Mile',
  'ae-faq1A':
    'EVs are cheaper to operate than gas cars. Electricity costs less than gasoline, and EVs use energy more efficiently, helping you go farther for less.',
  'ae-faq2': '🛠️ Less Maintenance, More Peace of Mind',
  'ae-faq2A':
    'No oil changes. Fewer moving parts. EVs require less upkeep, saving you time and money on repairs.',
  'ae-faq3': '😊 A Better Driving Experience',
  'ae-faq3A':
    "Experience the thrill of instant acceleration and responsive handling. EVs are quiet, powerful, and incredibly fun to drive—whether you're commuting or enjoying a weekend cruise.",
  'ae-faq4': '🌿🏙️ Cleaner for the Community',
  'ae-faq4A':
    "EVs produce no tailpipe emissions, which means cleaner air and fewer greenhouse gases in our city. By choosing electric, you are actively contributing to Austin's climate goals.",
  'ae-faq5': '🔌🏠🛣️ Charge at Home or On the Go',
  'ae-faq5A':
    'Plug in overnight at home or use the growing network of public charging stations around Austin, including fast chargers.',

  'ae-faq6': '🎁 Get Rewarded to Drive Electric',
  'ae-faq6A':
    'Take advantage of federal tax credits and Austin Energy rebates to make EV ownership even more affordable. If you are like most people and drive around 30 miles a day, an EV could mean more money in your pocket and more time for what matters.',

  'ae-main-faq1': '🚗⚡ What is an electric vehicle (EV)?',
  'ae-main-faq1A':
    '<p>An EV is a vehicle that uses electricity as its primary fuel. It can be:</p><ul><li><span>A <strong>Battery Electric Vehicle (BEV)</strong> that runs only on electricity, or </span></li><li><span>A <strong>Plug-in Hybrid Electric Vehicle (PHEV)</strong> that uses both electricity and gasoline. </span></li></ul>',

  'ae-main-faq2': '💰 Are EVs more expensive than gas vehicles?',
  'ae-main-faq2A':
    '<p>While EVs may cost more upfront, they are cheaper to operate. Lower fuel costs, fewer maintenance needs, and available rebates and tax credits often make EVs more affordable over time.</p>',

  'ae-main-faq3': '⚡  What are Level 1, Level 2, and DC Fast Charging?',
  'ae-main-faq3A':
    '<columns><column><img1></img1><p><strong>Level 1</strong></p><ul><li><span>Chargers that plug into a regular 120-volt home outlet, just like the one you use to charge your phone or toothbrush.</span></li><li><span>Slow charge rate: 3-5 miles per hour.</span></li><li><span>Useful for drivers traveling 40 miles or less daily.</span></li><li><span>Level 1 charging is best for charging at home overnight.</span></li></ul></column><column><img2></img2><p><strong>Level 2</strong></p><ul><li><span>240-volt chargers, like the one used for a clothes dryer outlet.</span></li><li><span>Medium charge rate: 15-30 miles per hour.</span></li><li><span>Useful for drivers traveling 100+ miles daily.</span></li><li><span>Level 2 charging is best when you have time to charge over several hours.</span></li></ul></column><column><img3></img3><p><strong>DC Fast Charging</strong></p><ul><li><span>Three connector types: CHAdeMO, SAE Combo (CCS), and NACS (Tesla).</span></li><li><span>Fast charge rate: 150-400 miles per hour.</span></li><li><span>Useful for long-distance driving 300+ miles daily.</span></li><li><span>Fast charging is best when you are on the go and need to charge your EV in under 30 minutes.</span></li></ul></column></columns>',

  'ae-main-faq4': '🔋 How far can I drive on a full charge?',
  'ae-main-faq4A':
    '<img1></img1><p>Most EVs today offer <strong>230-350 miles per charge</strong>, which covers <strong>multiple days of driving</strong> for the average Austin commuter (approx. 25 miles round trip daily).</p>',

  'ae-main-faq5': '🏡 Can I charge my EV at home?',
  'ae-main-faq5A':
    '<p>Yes! One of the biggest perks of driving an EV is to charge right at home while you sleep. While you can plug an EV into a regular 120-volt outlet, a Level 2 (240-volt) charging station gives you a faster charge. Austin Energy offers a <a1>rebate for a Level 2 home charger</a1>.</p><p>When to charge?<break></break>All electric vehicles come with timers that allow you to pre-set when the car charges. It is best to charge your electric vehicle between 10 p.m. and 6 a.m. when renewable wind power peaks and there is more capacity on the Texas grid. It is best to avoid charging your electric vehicle between 4 p.m. to 7 p.m. when there is typically less capacity in the Texas grid. <a2>(Texas Department of Transportation)</a2></p><p>➢ Get bill credits for using your home charger during periods of low energy demand through <a3>Power Partner℠ EV</a3>.</p>',

  'ae-main-faq6': '🏙️ What if I live in an apartment or rent?',
  'ae-main-faq6A':
    '<p>You can still go electric! <a></a>: Austin Energy offers charging options for EVeryone. No subscription required.</p>',
  'ae.chargeOnTheGo': 'Charge-On-The-Go',
  'ae-main-faq7': '📍 Where can I find public charging stations?',
  'ae-main-faq7A':
    '<p>Austin Energy\'s <a href="#" target="_blank">EV charging network</a> includes thousands of public stations, including fast charging. There are also other networks available all throughout Austin!</p>',

  'ae-main-faq8': '💰📋 What rebates and incentives are available?',
  'ae.checkCurrentIncentives': 'Check current incentives',
  'ae-main-faq8A': '<p><a></a></p>',

  'ae-main-faq9': '🌎  Are EVs really better for the environment?',
  'ae-main-faq9A':
    '<p>Yes. EVs produce zero tailpipe emissions and are more efficient overall, even when charged on today’s electric grid. They help improve air quality and reduce greenhouse gas emissions.</p>',

  'ae-main-faq10': '🚘  How do I choose the right EV for me?',
  'ae.findYourEvMatch': 'Find Your EV Match',
  'ae-main-faq10A':
    "<p>Use the EV Buyer's Guide to compare models by price, range, features, and more. Whether you drive daily, carpool, or want something fun, there's an EV that fits your life.</p><p><a></a></p>",
  'ae-main-faq11': '🧰  What about maintenance?',
  'ae-main-faq11A':
    '<p>EVs have fewer moving parts, no oil changes, and less wear on brakes. That means less maintenance and lower lifetime costs. </p>',

  'evCard.altText': 'Go to {makeModelTrim}',

  faqMainTitle: 'Frequently Asked Questions (FAQs)',
  faqMainDescription:
    'Ready to explore electric driving? This FAQ gives quick answers on charging, costs, incentives, and benefits so you can make the switch with confidence. With Austin Energy, going electric is easier and more affordable than ever.',

  factsSubheading:
    'Electric vehicles are easy! Here are five fun facts about EVs.',
  factsUseHeading: 'EASY TO USE',
  factsUseContent:
    'Plug into a regular outlet at home or use a charging station for a faster charge.',
  factsMaintain: 'EASY TO MAINTAIN',
  factsMaintainContent:
    'Enjoy more time and money in your pocket since EVs require less maintenance and have fewer moving parts.',
  factsCharge: 'EASY TO CHARGE',
  factsChargeContent:
    'Charge for only {amount} a month at any of the 800+ local Austin Energy charging ports powered by 100% renewable Texas wind energy.',
  factsDriveEasy: 'EASY TO DRIVE',
  factsDrivePerformance:
    'Get the high performance you want in a car, when you choose to lease, buy or get a used EV.',
  factsDriveContent: 'EASY TO FIND!',
  factsBrowse: 'Browse the new {website} to find your vehicle now! {link}',
  factsBrowseLink: 'See what EV drivers are saying.',

  faqHeading: 'Austin Energy EV FAQ',
  faqVehicles: 'Vehicles',
  'vehicle.miles': 'miles',
  'vehicle.trees': 'trees',
  'vehicle.view': 'View',
  'vehicle.more': 'more',
  'vehicle.fewer': 'fewer',
  'vehicle.greater': 'greater',

  'vehicle.plugInHybrid': 'Plug in Hybrid',
  'vehicle.allElectric': 'All Electric',
  'vehicle.gas': 'Gasoline',
  'vehicle.afterIncentives': 'AFTER INCENTIVES',
  'vehicle.msrp': 'MSRP',
  'vehicle.estimatedIncentives': 'ESTIMATED INCENTIVES',
  'vehicle.type': 'TYPE',
  'vehicle.fuelType': 'FUEL TYPE',
  'vehicle.batterySize': 'BATTERY SIZE',
  'vehicle.electricRange': 'ELECTRIC RANGE',
  'vehicle.timeToChargeLvlTwo': 'TIME TO CHARGE - LEVEL 2',
  'vehicle.milesPerThirtyFastCharge': 'MILES PER 30 MIN OF FAST CHARGING',
  'vehicle.coTwoEmissions': 'CO2 EMISSIONS REDUCTION',
  'vehicle.phev': 'Electricity and Gasoline',
  'vehicle.bev': 'Electricity',
  'vehicle.age.one': '0-1 years old',
  'vehicle.age.two': '2-3 years old',
  'vehicle.age.four': '4+ years old',

  'vehicle.type.sedan': 'Sedan',
  'vehicle.type.hatchback': 'Hatchback',
  'vehicle.type.coupe': 'Coupe',
  'vehicle.type.crossover': 'Crossover',
  'vehicle.type.minivan': 'Minivan',
  'vehicle.type.suv': 'SUV',
  'vehicle.type.wagon': 'Wagon',
  'vehicle.type.truck': 'Truck',

  'header.electricVehicles': 'Electric Vehicles',
  'header.compareVehicles': 'Compare Vehicles',
  'header.incentives': 'Incentives',
  'header.chargingStations': 'Charging Stations',
  'header.homeChargers': 'Home Chargers',

  pages: 'Pages',

  footerNavigationOtherResources: 'Other Austin Energy Resources',

  footerInventory: "Inventory - Austin Energy EV Buyer's Guide",
  findDealers: 'Find Dealers',
  evFAQ: 'EV FAQ',

  footerNavigationEVPrograms: 'Austin Energy EV Programs',
  footerNavigationSolar: 'Solar',
  footerNavigationGreenChoice: 'GreenChoice®',
  footerNavigationGreenBuilding: 'Austin Energy Green Building',
  footerNavigationRebatesIncentives: 'Rebates & Incentives',
  footerNavigationContact: 'Contact',

  'footer.pluginAustinEmail': 'pluginaustin@austinenergy.com',
  'footer.pluginAustinWebsite': 'Pluginaustin.com',

  'footer.compareVehicles': '{compareVehicles}',
  'footer.incentives': '{incentives}',
  'footer.chargingStations': '{chargingStations}',
  'footer.homeChargers': '{homeChargers}',
  'footer.poweredBy': 'Powered by Zappyride',

  'homepage.welcome': 'Colton Recharged',
  'homepage.welcomeSub':
    'Your electric car guide, brought to you by Colton Electric Utility. Estimate and compare costs, savings, EV Incentives, and more.',

  'homepage.linkCard.browseElectricVehicles':
    'BROWSE ELECTRIC {lineBreak} VEHICLES',
  'homepage.linkCard.researchElectricVehicles':
    'RESEARCH ELECTRIC {lineBreak} VEHICLES',
  'homepage.linkCard.discoverIncentives': 'DISCOVER {lineBreak} INCENTIVES',
  'homepage.linkCard.locateChargingStations':
    'LOCATE CHARGING {lineBreak} STATIONS',
  'homepage.linkCard.homeChargers': 'HOME {lineBreak} CHARGERS',
  'homepage.linkCard.findDealers': 'FIND {lineBreak} DEALERS',
  'homepage.linkCard.eRides':
    'Check out {ERides} to access rebates for electric bikes and more',
  'homepage.linkCard.learnMore':
    "Drive on the F1 COTA track at Electrify Expo this Nov 11-12. It's the biggest expo yet with the world’s best electric cars, trucks, bikes and more. {LearnMore}",

  'homepage.vehicleCarousel.title':
    'There are {vehicleCount} electric vehicles available. Discover yours.',
  'homepage.vehicleCarousel.subTitle':
    "Choose an EV and compare the cost to a similar gas vehicle. EVs can help you save money because {lineBreak} they're often cheaper to own and maintain than a 100% gasoline-powered competitor.",
  'homepage.vehicleCarousel.findEVButton': 'See All Vehicles',

  'homepage.fuelRangeChart.title':
    'How far can you drive the {car} on a {budget} fuel budget?',
  'graph.fuelRange.chart.description': 'Description',
  'graph.fuelRange.chart.rangeOn': 'Range on',
  'graph.fuelRange.chart.fuelBudget': 'fuel budget',
  'graph.fuelRange.chart.network': 'on Plug-In EVerywhere network',
  'graph.fuelRange.chart.unlimited': 'Unlimited',
  'graph.fuelRange.chart.chargedHome': 'charged at home',
  'graph.fuelRange.chart.similarGas': 'a similar Gas Vehicle',
  'graph.fuelRange.chart.miles': 'miles',
  'graph.fuelRange.chart.howFar':
    'How far can you drive the {car} on a {budget} fuel budget?',

  'graph.assumptions': 'Assumptions',
  'graph.yourEV': 'Your EV Selection',
  'graph.similarGasVehicle': 'Similar Gas Vehicle',
  'graph.graphValues': 'Graph Values',
  'graph.show': 'Show',
  'graph.hide': 'Hide ',
  'graph.moreExpensive': 'more expensive',
  'graph.cheaper': 'cheaper',
  'graph.toOwnOver': 'to own over ',
  'graph.years': ' Years',
  'graph.year': ' Year',

  'graph.costOfOwnership.title': 'Cost of Ownership',
  'graph.costOfOwnership.subTitle':
    'The {carName} is {style} {costDeltaText} {costDeltaTextEnding}',
  'graph.costOfOwnership.subTitleThreeCars':
    'The {carName} is the cheapest to own for {yearsOfOwnership} years',
  'graph.costOfOwnership.descriptionRow.vehicle': 'Vehicle',
  'graph.costOfOwnership.descriptionRow.maintenance': 'Maintenance',
  'graph.costOfOwnership.descriptionRow.insurance': 'Insurance',
  'graph.costOfOwnership.descriptionRow.electricity': 'Electricity',
  'graph.costOfOwnership.descriptionRow.gasoline': 'Gasoline',
  'graph.costOfOwnership.totalRow': 'Total',
  'graph.costOfOwnership.description': 'Description',

  'graph.costOfOwnership.chart.vehicle': 'Vehicle net Incentives, Resale',
  'graph.costOfOwnership.chart.electricity': 'Electricity',
  'graph.costOfOwnership.chart.gasoline': 'Gasoline',
  'graph.costOfOwnership.chart.maintenance': 'Maintenance',
  'graph.costOfOwnership.chart.insurance': 'Insurance',

  'graph.title.costAnalysis': 'Cost Analysis',
  'graph.title.speedOfCharge': 'Speed of Charge',
  'graph.title.electricRange': 'Electric Range',
  'graph.monthlyCostToFill.title': 'Cost to Fill Up Monthly',

  'graph.speedOfCharge.levelTwoChargingSpeed': 'Level 2 Charger Speed',
  'graph.speedOfCharge.fastChargingSpeed': 'Fast Charging Speed',
  'graph.speedOfCharge.mphLevelTwoCharger':
    'miles per hour with a level 2 charger',
  'graph.speedOfCharge.thirtyFastCharge':
    'miles per 30 minutes of fast charging',
  'graph.speedOfCharge.subTitle':
    'The {car} charges {number} {costDeltaText} {subTitleText}',
  'graph.speedOfCharge.mphLevelTwoChargerThreeCars':
    'charges the most miles per hour with a level 2 charger',
  'graph.speedOfCharge.thirtyFastChargeThreeCars':
    'charges the most miles per 30 minutes of fast charging',
  'graph.speedOfCharge.subTitleThreeCars': 'The {car} {subTitleText}',
  'graph.speedOfCharge.mphLevelTwoChargerTitle':
    'Amount of Charge Per Hour of Level 2 Charging',
  'graph.speedOfCharge.fastChargerTitle':
    'Amount of Charge Per 30 Minutes of Fast Charging',
  'graph.electricRange.subTitleThreeCars':
    'The {car} has the longest Electric Range',
  'graph.electricRange.subTitle':
    "The {car}'s electric range is {costDeltaText} by {number} miles",
  'graph.electricRange.gasolineRange': 'Gasoline Range',
  'graph.electricRange.assumption': 'Range based on EPA Estimates',
  'graph.monthlyCostToFill.subTitle':
    'The {carName} is {style} {costDeltaText} to fill up monthly',
  'graph.monthlyCostToFill.subTitleThreeCars':
    'The {carName} is cheapest to fill up monthly',

  'homepage.incentives.subTitle':
    'See how much you could save getting behind the wheel of an EV, whether you are buying or leasing. Incentives are personalized for {company} customers.',
  'homepage.incentives.exporeIncentives': 'EXPLORE INCENTIVES',
  'homepage.incentives.personalizeIncentivesButton': 'Personalize Incentives',

  'eRides.label': 'AUSTIN ENERGY{br}E-RIDE REBATE',
  'eRides.metroBike.title': 'MetroBike Access',
  'eRides.metroBike.subtitle':
    'No bike? No problem. Try a {metroBike} and enjoy a smooth ride around town for short trips without buying a bike.',
  'eRides.metroBike': 'Metrobike',
  'eRides.metroBike.try': 'Try a Metrobike',
  'eRides.metroBike.how': 'How to Use',
  'eRides.metroBike.find': 'Find Bikes',
  'eRides.metroBike.safety': 'Safety Tips',
  'eRides.bikeMap.title': 'Austin Bike Map',
  'eRides.bikeMap.subtitle': 'Austin’s biking network is growing every day.',
  'eRides.upTo': 'Up to',
  'eRides.vehicle': 'per vehicle*',
  'eRides.go': 'Go',
  'eRides.rebates.local': 'Local',

  'eRides.rebates.oneTitle': 'For Individual Customers',
  'eRides.rebates.twoTitle': 'For participants in the {link}',
  'eRides.rebates.two.title.link': 'Customer Assistance Program (CAP)',
  'eRides.rebates.threeTitle': 'For Fleet customers purchasing 5-25 E-Rides',
  'eRides.vehicles': 'per vehicle*',

  'erides.faqTitle': 'Why E-Rides Are a Smart Investment',
  'erides.faqDescription':
    "E-Rides are more than just fun—they're a practical, affordable way to get around Austin.",

  'erides.readyToRide.title': 'Ready to Ride?',
  'erides.readyToRide.description':
    'Start saving today. Find an {link} and apply for your rebate.',
  'erides.readyToRide.link': 'eligible dealer',

  'eRides.rebate.button': 'See rebate offerings and apply now',

  'eRides.rebate.title': 'How Much Can You Save?',

  'ae-erides-faq1': '✅ Low Cost, High Value',
  'ae-erides-faq1A':
    'Electric bikes and scooters cost far less than cars and require minimal upkeep. No gas, no oil changes—just plug in and go.',

  'ae-erides-faq2': '🚦 Beat the Traffic',
  'ae-erides-faq2A':
    'E-Rides help you skip the congestion and get around faster on bike lanes and urban trails.',

  'ae-erides-faq3': '🌎 Eco-Friendly Choice',
  'ae-erides-faq3A':
    'Every ride on an e-bike or scooter helps reduce carbon emissions and air pollution—good for you and for Austin.',

  'ae-erides-faq4': '🅿️ No Parking Stress',
  'ae-erides-faq4A':
    'Forget circling for a spot or paying for downtown parking. E-Rides can be stored at home or locked at any bike rack.',

  'ae-erides-faq5': '🔋 Perfect for Short Trips',
  'ae-erides-faq5A':
    "Whether it's commuting a few miles, grabbing groceries, or enjoying a scenic ride along Lady Bird Lake, E-Rides make short trips fun.",

  'eRides.rebates.localTitle':
    'Purchases must be made through an eligible dealer to qualify',

  'erides.bikemap.faqTitle': 'Get Around Austin - Your Way',
  'ae-erides-bikemap-faq2': '🚴 Try an E-Bike ‍⚡',
  'ae-erides-bikemap-faq2A':
    'Not ready to buy? No problem. {link} lets you borrow an e-bike for rides around central Austin.',
  'ae-erides-bikemap-faq2-link': 'Bikeshare',

  'erides.wantToRide':
    'Want to ride electric as well as drive? Check out the {link}.',
  'erides.wantToRide.link': 'E-Ride page',
  'homepage.incentives.title': 'EV Incentives and Tax Credits',
  'homepage.incentives.subtitle': 'Find out how much you could save on an EV.',
  'homepage.incentives.cta':
    'Live in an apartment building? Landlords and tenants, <a1>learn more</a1> about our Plug-in Austin EV Charging Station Rebate.',

  'compareVehicles.subTitle': 'See All Vehicles >',
  'compareVehicles.selectFuel': 'Select a Fuel Type',
  'compareVehicles.selectMake': 'Select a Make',
  'compareVehicles.selectModel': 'Select a Model',
  'compareVehicles.pickTwo': 'Pick at least 2 vehicles to start the comparison',
  'compareVehicles.disclaimer': 'Not all make / models are available.',

  'evs.welcomeSub':
    'Compare electric vehicles by range, price, or your personalized Match Score. Click on the EV for more details, including total cost compared to a similar gas vehicle.',
  'evs.buttonMatchScoreAndFilters': 'Match Score and Filters',
  'evs.matchScoreAndFilters': 'Refine Match Score and Filters',
  'evs.matchScoreOptions': 'Refine Match Score',
  'evs.roundTripCommute': 'Roundtrip Commute',
  'evs.budgetAfterIncentives': 'Budget after Incentives',
  'evs.minSeats': 'Minimum Seats',
  'evs.seats': 'seats',
  'evs.homeChargingAvailability': 'Home Charging Availability',
  'evs.homeChargingAvailabilityTooltip':
    'More electric vehicles will be convenient for you if you can charge quickly at home.',
  'evs.noCharging': 'No Charging',
  'evs.levelOne': 'Level 1',
  'evs.levelTwo': 'Level 2',
  'evs.helpMeChoose': 'Help Me Choose',
  'evs.chargingAvailability': 'Charging Availability',
  'evs.disclaimer':
    'Vehicles displayed may not reflect actual availability. {company} does not endorse or recommend any specific vehicle or car manufacturer.',

  vehiclesAvailabilityButton: 'Local Vehicles Only',

  'chargingWizard.carOvernight': 'Where will you park your car overnight?',
  'chargingWizard.parkingGarage': 'Private garage or parking spot',
  'chargingWizard.onTheStreet': 'On the street',
  'chargingWizard.publicParking': 'Public parking lot',
  'chargingWizard.electricianInstall':
    'Would an electrician be allowed to install a charging station?',
  'chargingWizard.overnightParking':
    'Could you park the car overnight in a spot equipped with a charging station?',
  'chargingWizard.powerOutlet':
    'Is there a regular power outlet close to where you park your car?',
  'chargingWizard.chargingAvailability': ' charging availability',
  'chargingWizard.noChargingAvailability': 'no charging availability',
  'chargingWizard.youWouldHave': 'you would have {resultText} ',
  'chargingWizard.useThisValue': 'Use this value',

  evfilter: 'Filter',
  'evfilter.fuel': 'Fuel',
  'evfilter.fuelTooltip':
    'All-electric vehicles use electricity only. Plug-in hybrids can use electricity and gasoline.',
  'evfilter.type': 'Type',

  yes: 'Yes',
  no: 'No',
  availability: 'Availability',
  'availability-Tooltip':
    'These vehicles have been seen in local Austin area dealer inventory in the recent past.',

  vehiclesFuelTip:
    'All-electric vehicles use electricity only. Plug-in hybrids can use electricity and gasoline.',

  'evCard.electricRange': 'Electric Range',
  'evCard.totalRange': 'Total Range',
  'evCard.matchScore': 'MATCH SCORE',
  'evCard.seeDetails': 'See Details',
  'evCard.seeElectricVehicle': 'See Electric Vehicle',

  'evSort.title': 'Sort By',
  'evSort.matchScore': 'Match Score',
  'evSort.electricRange': 'Electric Range',
  'evSort.priceLtH': 'Price: Low to High',
  'evSort.priceHtL': 'Price: High to Low',
  'evSort.alphabetical': 'Alphabetical',

  inventoryFilter: 'Filter Vehicles',
  inventoryAll: 'All',
  inventoryNew: 'New',
  inventoryUsed: 'Used',

  'pricePanels.cash': 'Cash',
  'pricePanels.loan': 'Loan',
  'pricePanels.lease': 'Lease',
  'pricePanels.loanPayment': 'Loan Payment',
  'pricePanels.downPayment': 'Down Payment',
  'pricePanels.leasePayment': 'Lease Payment',
  'pricePanels.perMonth': ' / month',
  'pricePanels.downPaymentDescription': '10% of MSRP plus tax',
  'pricePanels.firstLeasePayment': 'FIRST LEASE PAYMENT',
  'pricePanels.incentivesForLease': 'Incentives For Lease',
  'pricePanels.seeAllIncentives': 'See All Incentives',
  'pricePanels.seeAllCosts': 'See All Costs',

  'ev.jumbotron.viewAllCars': 'View All Cars',
  'ev.jumbotron.disclaimer':
    'See the {evFacts} and the {faq} pages for detailed explanations about your EV.',
  'ev.carDetails.fastChargingTooltip': 'DC Fast Charger Speed:',
  'ev.carDetails.levelTwoChargerSpeedTooltip': 'Level 2 Charger Speed:',
  'ev.carDetails.batterySizeTooltip':
    'One kilowatt-hour (kWh) is enough energy to drive 1 to 4 miles, depending on the vehicle. A typical laptop battery can hold less than 0.1 kWh.',
  'ev.carDetails.treesPlanted': 'Trees Planted',
  'ev.carDetails.gasolineSaved': 'Gasoline Saved',
  'ev.carDetails.compareText':
    'We selected the {gasVehicle} based on its proximity to the {vehicle} based on brand, size, and price.',
  'ev.cardetails.calc.dcRate': 'DC Fast Charging (DCFC) Rate',
  'ev.cardetails.calc.EPA': 'EPA Efficiency Rating',
  'ev.cardetails.calc.chargingRate': 'Charging Rate',
  'ev.cardetails.calc.vehicleBatteryCapacity': 'Vehicle Battery Capacity',
  'ev.cardetails.calc.maxACIntake': 'Vehicle Max AC Intake',
  'ev.cardetails.calc.lvlTwoChargingRate': 'Level 2 Charging Rate',
  'ev.cardetails.calc.minOflvl2AC':
    'Minimum of Level 2 Charging Rate and Vehicle Max AC Intake',
  'ev.cardetails.calc.lvl2FullCharge': 'Time to Full Charge for Level 2',
  'ev.cardetails.calc.milesDrivenPerYr': 'Miles driven per year',
  'ev.cardetails.calc.userInput': 'User Input',
  'ev.cardetails.calc.milesPerGallon': 'Miles Per Gallon (MPG)',
  'ev.cardetails.calc.mpg': ' miles/gal',
  'ev.cardetails.calc.portionElectric': 'Portion of Electric Driving',
  'ev.cardetails.calc.portionElectricSource':
    'User input. For a hybrid vehicle, estimates the portion of miles driven using the electric battery instead of gasoline.',
  'ev.cardetails.calc.gallonsUsed': 'Gallons Used',
  'ev.cardetails.calc.gallonsUsedFormula':
    'Miles driven * (1 - Portion of Electric Driving) / MPG',
  'ev.cardetails.calc.gallonsSaved': 'Gallons Saved',
  'ev.cardetails.calc.gallonsSavedFormula':
    'Gallons used by Equivalent Gas Vehicle - Gallons used by EV',
  'ev.cardetails.calc.electricEmissions': 'Electric Emissions in Lbs',
  'ev.cardetails.calc.electricEmissionsLbsMwh': 'Electric Emissions in Lbs/MWh',
  'ev.cardetails.calc.EIA': 'U.S. Energy Information Administration',
  'ev.cardetails.calc.gasolineEmissionsYr':
    'Gasoline Emissions in lbs of CO2/yr',
  'ev.cardetails.calc.gasolineEmissions':
    'Gasoline Emissions in Lbs per Gallon',
  'ev.cardetails.calc.emissionsReudctions': 'Emissions Reductions',
  'ev.cardetails.calc.lbsCo2PerYr': ' lbs of CO2 per year',
  'ev.cardetails.calc.gasolineEmissionsLbs': 'Gasoline Emissions in Lbs',
  'ev.cardetails.calc.arborDayFoundation': 'Arbor Day Founadtion',
  'ev.cardetails.calc.emissionsPerTree': 'Emissions Saved per Tree',
  'ev.cardetails.calc.electricityEmissions':
    'Electricity Emissions in CO2 lbs/MWh',
  'ev.usedCarTitle': 'Used {car}',
  'ev.cardetails.electricRange':
    'To account for battery degradation, the range quoted here is an estimation based on the age of the vehicle and normal driving/charging patterns.',
  'ev.carDetails.usedBatterySizeTooltip':
    'One kilowatt-hour (kWh) is enough energy to drive 1 to 4 miles, depending on the vehicle. To account for battery degradation for a used EV, the battery size quoted here is an estimation based on the age of the vehicle and normal driving/charging patterns.',

  'ev.purchaseMethod': 'Purchase Method',
  'ev.purchaseMethodToolTip':
    'In a lease, you have to return the car after the lease period. In the case of loan financing, you keep the car after the loan is paid off.',
  'ev.cash': 'Cash',
  'ev.loan': 'Loan',
  'ev.lease': 'Lease',
  'ev.milesDrivenAnnually': 'Miles Driven Per Year',
  'ev.electricPortion': 'Portion Electric for PHEV',
  'ev.electricPortionTooltip':
    'A Plug-In Hybrid Electric Vehicle (PHEV) can use both electricity and gasoline. It is usually more beneficial to use electricity.',
  'ev.yearsOwnership': 'Years of Ownership/Lease',
  'ev.interestRate': 'Interest Rate',
  'ev.electricityRateCalc':
    'Electricity rate is calculated as a blended rate based off an average household consumption of 700 kWh. To learn more, please click {website}',

  'assumption.salesTax': 'Sales Tax',
  'assumption.gasolinePrice': 'Price of Gasoline',
  'assumption.downPayment': 'Down Payment',
  'assumption.electricityRate': 'Electricity Rate',
  'assumption.downPaymentValue': '10% of MSRP + Tax',

  'ev.compareGasVehicle':
    'Compare the {car} to a similar gas vehicle, the {gasCar}',
  'ev.compareOtherVehicles': 'COMPARE OTHER VEHICLES',
  'ev.incentives.title':
    'Up to {savings} in tax credits and rebates are potentially available for the {car}',
  'ev.reviews': 'Reviews from around the web',

  'chargingMap.updateZipcode': 'UPDATE ZIP CODE',
  'chargingMap.errorZipcode': 'Error: {workingZipcode} is not a valid zipcode',
  'chargingMap.showFullListOfStations': 'FULL LIST OF STATIONS',
  'chargingMap.public': 'Public stations',
  'chargingMap.businessGovernment': 'Installed by business or government',
  'chargingMap.highPowerStations': 'High Power Stations',
  'chargingMap.DCChargers': 'DC fast charge or superchargers',
  'chargingMap.otherSttations': 'Other Types of Stations',
  'chargingMap.privateStations': 'Private stations',
  'chargingMap.searchDealers': 'Search Qualified Dealers',

  'dealers.brands': 'Brands',
  'dealers.allBrands': 'All Brands',
  'dealers.allDealers': 'All Dealers',
  'dealers.contact': 'CONTACT',
  'dealers.website': 'WEBSITE',
  'dealers.findDealers': 'Find Dealers',

  'incentives.title': 'Electric Vehicle Incentives',
  'incentives.subTitle':
    'You may be eligible for a range of incentives, including rebates, tax credits, and various other benefits. Incentives are personalized for where you live.',
  'incentives.single': 'Single',
  'incentives.married': 'Married',
  'incentives.headOfHousehold': 'Head of Household',
  'incentives.vehicleType': 'Vehicle Type',
  'incentives.vehicleTypeTooltip':
    'Certain incentives depend on which car you purchase.',
  'incentives.tradeIn': 'Trade-In',
  'incentives.income': 'Income and tax status',
  'incentives.incomeTooltip':
    'Incentive eligibility and the amount you can receive often depends on your income. Lower  income customers are typically eligible for higher rebates.',
  'incentives.clunkerNone':
    'Certain incentives compensate you for retiring an existing vehicle, also known as a clunker.',
  'incentives.clunkertoolTip':
    'Certain incentives compensate you for retiring an existing vehicle, also known as a clunker. Specifically, the ',
  'incentives.clunkertoolTipContd':
    ' are available in your region. Eligibility requirements vary by incentive; please check program details.',
  'incentives.householdSize': 'Household Size',
  'incentives.householdIncome': 'Household Income',
  'incentives.planClunker': 'Are you planning to turn in a clunker?',
  'incentives.location': 'Location',
  'incentives.locationTooltip':
    'Many incentives depend on where you live. Enter your zipcode to help determine what incentives are available where you live.',
  'incentives.taxFilingStatus': 'Tax Filing Status',
  'incentives.whichVehicle': 'Which vehicle do you plan to purchase?',
  'incentives.incentiveEligibility': 'Update Incentive Eligibility',

  'erides.bigPromise.title': 'Save Money. Ride Electric.',
  'erides.bigPromise.description':
    'Austin Energy offers rebates to help you purchase eligible electric bikes, scooters, mopeds, and other two- or three-wheel electric vehicles.',
  'eRides.rebate.description':
    'All purchases must be made through an {link} to qualify.',
  'eRides.rebate.description.link': 'eligible local dealer',

  'homeChargers.subText':
    'Select the vehicle you are interested in to see the specific charging time to a full battery.',
  'homeChargers.wallMounted': 'Wall Mounted',
  'homeChargers.portable': 'Portable',
  'homeChargers.price': 'Price',
  'homeChargers.cordLength': 'Cord Length',
  'homeChargers.wifi': 'WiFi Connectivity',
  'homeChargers.socket': 'Socket',
  'homeChargers.socketTooltip':
    "Different model chargers have different plug patterns. These plug patterns correspond to the way prongs fit into your wall outlet. If you're note sure which is best for your home/garage, check with a qualified electrician.",
  'homeChargers.cordLengthLtH': 'Cord Length: Low to High',
  'homeChargers.cordLengthHtL': 'Cord Length: High to Low',
  'homeChargersCard.buy': 'Details & Buy',
  'homeChargersCard.beforeIncentives': 'Before Incentives',
  'homeChargersCard.socket': '{socket} Socket',
  'homeChargers.cable': '{length} ft. Cable',
  'homeChargers.hardwired': 'Hardwired',
  'homeChargers.toFullCharge': 'to full charge',

  'electricians.residential': 'Residential',
  'electricians.commercial': 'Commercial',
  'electricians.industrial': 'Industrial',
  'electricians.type': 'Electrician Type',
  'electricians.searchElectricians': 'Search Qualified Electricians',

  'activate.membership': 'Activate your',

  'footer.customerServices': 'Customer Services',
  'footer.phoneMain': '512-494-9400',
  'footer.outsideAustin': 'Outside Austin call toll-free:',
  'footer.phoneTollFree': '888-340-6465',
  'footer.contactUs': 'Contact Us',
  'footer.cityUtilities': 'City of Austin Utilities Online',
  'footer.startService': 'Start/Manage Service',
  'footer.billingPayment': 'Billing & Payment',
  'footer.billDisputes': 'Bill Disputes',

  'footer.disabilityAssist': 'Disability Assistance',
  'footer.vrsCalls': 'VRS calls are accepted',
  'footer.requestAccommodations': 'Request Accommodations',

  'footer.reportOutages': 'Report Outages',
  'footer.outagePhone': '512-322-9100',
  'footer.viewOutages': 'View Outages Online',
  'footer.reportOutage': 'Report Outage & View Status',
  'footer.outageAlerts': 'Outage Alerts',

  'footer.renewableEnergy': 'Renewable Energy',
  'footer.greenChoice': 'GreenChoice® Wind Energy',
  'footer.solar': 'Solar for Home or Business',
  'footer.electricVehicles': 'Electric Vehicles',

  'footer.helpHighBills': 'Help With High Bills',
  'footer.manageEnergy': 'Manage Your Energy Costs',
  'footer.customerAssistPrograms': 'Customer Assistance Programs',
  'footer.weatherization': 'Weatherization Assistance',

  'footer.energyEfficiency': 'Energy Efficiency',
  'footer.rebates': 'Rebates & Incentives',
  'footer.greenBuilding': 'Green Building',
  'footer.ecad': 'ECAD Ordinance & Energy Audits',

  'footer.spotlight': 'In the Spotlight',
  'footer.austinUtilitiesNow': 'Austin Utilities Now',

  'footer.aboutAE': 'About Austin Energy',
  'footer.whoWeAre': 'Who we are',
  'footer.history': 'Our History',
  'footer.reports': 'Corporate Reports',
  'footer.news': 'News',
  'footer.careers': 'Careers',

  'footer.electricRates': 'Electric Rates',
  'footer.residentialRates': 'Residential Rates',
  'footer.commercialRates': 'Commercial Rates',

  'footer.initiatives': 'Initiatives & Outreach',
  'footer.environment': 'Environment',
  'footer.communitySchools': 'Community & Schools',

  'footer.safety': 'Safety',
  'footer.callBeforeDig': 'Call 8-1-1 Before You Dig',
  'footer.electricalSafety': 'Electrical Safety',
  'footer.safetyDuringOutage': 'Safety During Outages',
  'footer.treeTrimming': 'Tree Trimming Services',

  'footer.commercialIndustrial': 'Commercial & Industrial',
  'footer.commercialApp': 'Commercial Web App',
  'footer.multifamilyProgram': 'Multifamily Partnership Program',
  'footer.districtEnergy': 'District Energy & Cooling',
  'footer.energyProfiler': 'Energy Profiler Online',
  'footer.electricDesignCriteria': 'Electric Design Criteria & ESPA',

  'footer.followUs': 'Follow Us',

  'footer.disclaimerText':
    'Figures shown on this page are estimates based on data provided by third-parties. This material is provided for informational purposes only and should not be relied on for tax, legal, or financial advice. Neither J.D. Power® nor Austin Energy provides tax, legal or financial advice. You should independently verify the estimates provided here before engaging in any transaction.',
  'footer.allRights': 'All Rights Reserved.',
  'translate-link-english': 'English',
  'translate-link-spanish': 'Spanish',
};
